exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".a-back-to-top[data-v-64c74420]{cursor:pointer;position:fixed;z-index:0}.icon[data-v-64c74420]{-webkit-transform:rotate(180deg);-ms-transform:rotate(180deg);transform:rotate(180deg)}.icon[data-v-64c74420]  .sf-icon{-webkit-transform:translateY(25%);-ms-transform:translateY(25%);transform:translateY(25%)}\n", ""]);

// exports
